import labels from '../constants/label'
var axios = require('axios');
export default class Networking {
    static PostApi(url, data = '') {
        var config = {
            method: 'post',
            url: url,
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            data: data
        };

        return axios(config)
            .then(function (response) {
                return response.data

            })
            .catch(function (error) {
                return labels.apiError.status
            });

    }
    static GetApi(url, data = '') {
        var config = {
            method: 'get',
            url: url,
            headers: {
            },
            data: data
        };

        return axios(config)
            .then(function (response) {
                return response.data;
            })
            .catch(function (error) {
                return labels.apiError.status
            });

    }
    // static FormPost(url, data = '') {
    //     const apiurl = ApiValues.BaseUrl + url;
    //     //  (apiurl)
    //     return fetch(apiurl, {
    //         method: 'POST',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'multipart/form-data',
    //             "apikey": "f3251620-b17e-45c9-9f38-60f31f27f7e8",
    //         },
    //         body: data
    //     })
    //         .then(response => response.json())
    //         .then(function (response) {
    //             return response;
    //         })
    //         .catch(error => {
    //             //  (error);
    //             return error;
    //         })
    // }
   
}
